module.exports = __webpack_public_path__ + "img/empty.8d25ed3d.png";